import { Checkbox, FormControlLabel } from "@mui/material";
import React, { useState, useEffect } from "react";
import IconCheckbox from "./IconCheckbox";
import styles from "./styles";
import { FieldMetaState, FieldRenderProps } from "react-final-form";

interface Props {
  input?: any;
  meta?: FieldMetaState<string | boolean>;
  id: string | number;
  name: string;
  value: boolean;
  label: string;
  errorMessage?: string;
  onChangeValue?: (id: string | number, checked: boolean) => void;
  required?: boolean;
  disabled?: boolean;
}

const InputCheckbox: React.FC<Props & FieldRenderProps<any, HTMLElement, any>> =
  ({
    input,
    meta,
    id,
    name,
    value,
    label,
    required = false,
    onChangeValue,
    disabled,
  }) => {
    const [checked, setChecked] = useState<boolean>(
      value || input?.value || meta?.initial || false
    );

    useEffect(() => {
      if (value !== undefined) {
        setChecked(value);
      } else if (input?.value !== undefined) {
        setChecked(input.value);
      } else if (meta?.initial !== undefined) {
        setChecked(meta?.initial);
      } else {
        setChecked(false);
      }
    }, [value, input, meta]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const isChecked = e.target.checked;
      setChecked(isChecked);

      if (input) {
        input.onChange(isChecked);
      }
      if (onChangeValue) {
        onChangeValue(id, isChecked);
      }
    };

    return (
      <FormControlLabel
        sx={styles}
        disabled={disabled}
        className="root"
        control={
          <Checkbox
            className="checkbox"
            required={required}
            name={name}
            checked={checked}
            onChange={handleChange}
            icon={<IconCheckbox />}
            checkedIcon={<IconCheckbox checked />}
          />
        }
        label={label}
      />
    );
  };

export default InputCheckbox;
